/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApplicationNoteDto
 */
export interface ApplicationNoteDto {
  /**
   *
   * @type {string}
   * @memberof ApplicationNoteDto
   */
  noteId: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationNoteDto
   */
  authorEmail: string;
  /**
   *
   * @type {string}
   * @memberof ApplicationNoteDto
   */
  body: string;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApplicationNoteDto
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof ApplicationNoteDto
   */
  updatedAt: OffsetDateTime;
}

/**
 * Check if a given object implements the ApplicationNoteDto interface.
 */
export function instanceOfApplicationNoteDto(
  value: object,
): value is ApplicationNoteDto {
  if (!("noteId" in value) || value["noteId"] === undefined) return false;
  if (!("authorEmail" in value) || value["authorEmail"] === undefined)
    return false;
  if (!("body" in value) || value["body"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("updatedAt" in value) || value["updatedAt"] === undefined) return false;
  return true;
}

export function ApplicationNoteDtoFromJSON(json: any): ApplicationNoteDto {
  return ApplicationNoteDtoFromJSONTyped(json, false);
}

export function ApplicationNoteDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApplicationNoteDto {
  if (json == null) {
    return json;
  }
  return {
    noteId: json["noteId"],
    authorEmail: json["authorEmail"],
    body: json["body"],
    createdAt: json["createdAt"],
    updatedAt: json["updatedAt"],
  };
}

export function ApplicationNoteDtoToJSON(json: any): ApplicationNoteDto {
  return ApplicationNoteDtoToJSONTyped(json, false);
}

export function ApplicationNoteDtoToJSONTyped(
  value?: ApplicationNoteDto | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    noteId: value["noteId"],
    authorEmail: value["authorEmail"],
    body: value["body"],
    createdAt: value["createdAt"],
    updatedAt: value["updatedAt"],
  };
}
